import dayjs from "dayjs";
import { convertUTCDate } from "../../utils/convertionFunc";
import enrollmentServices from "../../Services/enrollmentServices";

export const BOOKAPPOINTMENTREQ = "BOOKAPPOINTMENTREQ";
export const BOOKAPPOINTMENTSUCCESS = "BOOKAPPOINTMENTSUCCESS";
export const BOOKAPPOINTMENTFAILED = "BOOKAPPOINTMENTFAILED";

export const SET_SELECTED_APPOINTMENT = "SET_SELECTED_APPOINTMENT";
export const CLEAR_SELECTED_APPOINTMENT = "CLEAR_SELECTED_APPOINTMENT";

export const bookFreeAppointment = (payload) => async (dispatch) => {
  dispatch({ type: BOOKAPPOINTMENTREQ });

  const type = payload.consultationType;

  try {
    let data = {
      consultationReason: payload?.consReason,
      complaintCode: payload?.complaintCode ?? "",
      createdBy: payload?.selectedDoctor?.userId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      account_Id: payload?.selectedDoctor?.account_Id,
      clinic_Id: payload?.selectedDoctor?.clinic_Id,
      firstName: payload?.selectedPatient?.firstName,
      specialityCode: payload?.selectedDoctor?.specialityCode,
      mobile: payload?.selectedPatient?.mobile,
      modifiedBy: payload?.selectedDoctor?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      patientId: payload?.selectedPatient?.patientId,
      paymentConsultation: "BC",
      paymentType: "Cash",
      appointmentDate: dayjs(payload.selectedDate).format("MM/DD/YYYY"),
      startTime: dayjs(payload?.selectedSlot, "HH:mm").format("hh:mm A"),
      endTime: dayjs(payload?.selectedSlot, "HH:mm")
        .add(15, "minute")
        .format("hh:mm A"),

      serviceCode:
        type === "video"
          ? "APPT_VIDEO"
          : type === "inPerson"
          ? "APPT_INPERSON"
          : "APPT_HOMEVISIT",

      serviceName:
        type === "video"
          ? "Video Consultation"
          : type === "inPerson"
          ? "Inperson Consultation"
          : "Homevisit Consultation",
      consultationFee: 0,
      totalAmount: 0,
      userId: payload?.selectedDoctor?.userId,
      patientType: "E",
      patientRegFeeYN: "N",
      paymentReceived: "Y",
      status: 1,
    };
    const res = await enrollmentServices.Invite(data);

    dispatch({
      type: BOOKAPPOINTMENTSUCCESS,
      payload: res.data,
    });
    return res;
  } catch (error) {
    dispatch({
      type: BOOKAPPOINTMENTFAILED,
      error: error.message,
    });
    throw error;
  }
};

export const setSelectedAppt = (appt) => ({type:SET_SELECTED_APPOINTMENT,payload:appt});
export const clearSelectedAppt = (appt) => ({type:CLEAR_SELECTED_APPOINTMENT,payload:appt});
